export const motoFormTheme = {
  header: 'palette.tertiary.90',
  modalMessage: 'palette.tertiary.90',
};
